export enum ThresholdSubtype {
    'temperature',
    'carbondioxide',
    'humidity',
    'occupancy'
}